import { useUser } from '../auth/useUser';

export function useSubscriptionStatus() {
    const {
        hasProSubscription,
        subscriptionExpiresAt,
        scheduledCancellation,
        cancelledAt
    } = useUser();

    // Helper to format date with +1 day adjustment (matching original logic)
    const formatRenewalDate = (dateStr) => {
        if (!dateStr) return '—';
        const date = new Date(dateStr);
        date.setDate(date.getDate() + 1);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    };

    const isCancelled = !!scheduledCancellation;
    const isPro = !!hasProSubscription;

    // Determine the relevant date to show
    // If cancelled, we typically show when it ends (expiresAt)
    // If active, we show when it renews (expiresAt)
    // The previous logic used the same date field but labeled it differently
    const relevantDateRaw = subscriptionExpiresAt;
    const formattedDate = formatRenewalDate(relevantDateRaw);

    let label = '';
    let status = 'free';

    if (isPro) {
        if (isCancelled) {
            status = 'cancelled';
            label = `Ends ${formattedDate}`;
        } else {
            status = 'active';
            label = `Renews ${formattedDate}`;
        }
    }

    return {
        isPro,
        isCancelled,
        status,       // 'active', 'cancelled', 'free'
        date: formattedDate,
        label,        // e.g. "Renews Feb 2, 2026" or "Ends Feb 2, 2026"
        subscriptionExpiresAt,
        scheduledCancellation,
        formatRenewalDate // exposing helper in case custom formatting is needed elsewhere
    };
}
